import Link from '@/components/Link'
import useTenant from '@/hooks/useTenant'
import { resolveLogoVariant } from '@caterdesk/ui--feedr-logo'
import { AppBar, Box, Grid, Toolbar, useTheme } from '@mui/material'
import { Stack } from '@mui/system'

import { transparentize } from 'polished'
import React from 'react'

import ipadShadow from './img/ipad_shadow.png'
import leaf from './img/leaf.png'
import urbanGreensSalad from './img/urban_greens_salad.png'

export default function RootLayout({ children }: { children: React.ReactNode }) {
  const tenant = useTenant()
  const theme = useTheme()

  const backgroundImage = tenant.marketing.assets?.authBackgroundImage

  return (
    <Box height="100%">
      <AppBar color="inherit">
        <Toolbar>
          <Link href="/">
            <img
              src={resolveLogoVariant({
                setToRainbowDuringPride: true,
                logos: tenant.marketing.logos,
              })}
              alt="Logo"
              height={50}
            />
          </Link>
        </Toolbar>
      </AppBar>

      <Grid container spacing={2} height="100%" margin={0}>
        <Grid size={{ xs: 12, md: 7, lg: 6, xl: 5 }} height="100%">
          <Stack flex={1} direction="column" justifyContent="center" height="100%">
            {children}
          </Stack>
        </Grid>

        <Grid size={{ xs: 0, md: 5, lg: 6, xl: 7 }} p={0}>
          <Stack
            height="100%"
            flex={1}
            direction="column"
            justifyContent="center"
            sx={{
              backgroundColor: transparentize(0.9, theme.palette.primary.main),
              backgroundRepeat: 'no-repeat',
              ...(backgroundImage
                ? {
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                  }
                : {
                    backgroundImage: `url(${urbanGreensSalad.src}), url(${ipadShadow.src}), url(${leaf.src})`,
                    backgroundPosition: '-144px -48px, left -192px bottom -200px, right top -48px',
                    backgroundSize: '416px, 896px, 224px',
                  }),
            }}></Stack>
        </Grid>
      </Grid>
    </Box>
  )
}
